"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GetTestIdValues = void 0;
var NavigationMobileStyles = _interopRequireWildcard(require("./NavigationMobileStyles"));
var _MenuDrawerStyles = require("./MenuDrawerStyles");
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _Logo = _interopRequireDefault(require("./Logo"));
var _Menu = _interopRequireDefault(require("@mui/icons-material/Menu"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _debounce = require("../../utils/performance/debounce");
var _array = require("../../utils/type-checks/array");
var _object = require("../../utils/type-checks/object");
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _MenuDrawer = _interopRequireWildcard(require("./MenuDrawer"));
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const merge = require("deepmerge"),
  GetTestIdValues = testId => {
    return {
      componentTestId: testId ? testId : undefined,
      drawerTestId: testId ? `${testId}_drawer` : undefined,
      dividerTestId: testId ? `${testId}_divider` : undefined,
      fragmentTestId: testId ? `${testId}_fragment` : undefined,
      menuButtonId: testId ? `${testId}_hamburger-button` : undefined,
      menuButtonIconId: testId ? `${testId}_hamburger-button-icon` : undefined
    };
  };

/**
 * Mobile Navigation Component
 *
 * @visibleName Mobile Navigation
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.GetTestIdValues = GetTestIdValues;
const NavigationMobile = props => {
  if (!(0, _object.isObject)(window.PubSub)) {
    window.PubSub = require("pubsub-js");
  }
  const {
      anchor = "right",
      autoOpen = false,
      bundledStyles = {},
      categoryArray,
      customTheme = {},
      indicator = "default",
      isDesktop = false,
      logo = {
        alt: "The Pennsylvania Higher Education Assistance Agency",
        src: `${process.env.PUBLIC_URL}/general/images/header/logo.svg`,
        height: "5.4rem",
        width: "13.7rem"
      },
      signInFragmentId,
      supplementalFragment = "13dqqi7",
      testId,
      variant = "default"
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    {
      customButtonStyles = {},
      customDividerStyles = {},
      customDrawerPaperStyles = {},
      customFragmentStyles = {},
      customLogoStyles = {},
      customMenuButtonIconStyles = {},
      customParentButtonStyles = {}
    } = bundledStyles,
    [open, setOpen] = (0, _react.useState)(autoOpen),
    buttonId = "navigation-mobile__button",
    testIdMap = GetTestIdValues(testId),
    dividerStyles = merge((0, _MenuDrawerStyles.DividerStyles)(theme, variant), customDividerStyles),
    drawerPaperStyles = merge((0, _MenuDrawerStyles.DrawerPaperStyles)(theme, isDesktop ? "none" : "block", variant), customDrawerPaperStyles),
    fragmentStyles = merge((0, _MenuDrawerStyles.FragmentStyles)(theme, variant), customFragmentStyles),
    menuButtonIconStyles = merge(NavigationMobileStyles.MenuButtonIconStyles(theme, variant), customMenuButtonIconStyles),
    parentButtonStyles = merge.all([(0, _MenuDrawerStyles.ButtonStyles)(theme, variant), customButtonStyles, customParentButtonStyles]),
    toggleDrawer = (0, _react.useCallback)((e, open) => {
      (0, _MenuDrawer.ToggleDrawer)(e, open, setOpen);
    }, [setOpen]);
  (0, _react.useEffect)(() => {
    const CloseWatcher = window.PubSub.subscribe("navigation.mobile.close", () => {
      toggleDrawer(null, false);
    });
    return () => {
      window.PubSub.unsubscribe(CloseWatcher);
    };
  }, [anchor, toggleDrawer]);
  (0, _react.useEffect)(() => {
    const handleResize = (0, _debounce.debounce)(() => {
      if (open && isDesktop) {
        toggleDrawer(null, false);
      }
    }, 50);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isDesktop, open, toggleDrawer]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    "data-testid": testIdMap.componentTestId,
    "data-mobile-array-indicator": indicator
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    "data-testid": testIdMap.menuButtonId,
    onClick: e => toggleDrawer(e, true),
    title: "Navigation Menu Button"
  }, /*#__PURE__*/_react.default.createElement(_Menu.default, {
    "data-testid": testIdMap.menuButtonIconId,
    sx: menuButtonIconStyles
  })), /*#__PURE__*/_react.default.createElement(_material.Drawer, {
    anchor: anchor,
    "data-testid": testIdMap.drawerTestId,
    id: buttonId,
    open: open,
    onClose: () => window.PubSub.publish("navigation.mobile.close"),
    PaperProps: {
      sx: {
        ...drawerPaperStyles
      }
    }
  }, logo && /*#__PURE__*/_react.default.createElement(_Logo.default, {
    logo: logo,
    customLogoStyles: customLogoStyles
  }), (0, _string.isStringOfLength)(signInFragmentId) && /*#__PURE__*/_react.default.createElement(_MenuDrawer.default, {
    backLabel: "Main Menu",
    bundledStyles: bundledStyles,
    customTheme: customTheme,
    label: "Sign In",
    logo: logo,
    isDesktop: isDesktop,
    isSignIn: true,
    fragmentId: signInFragmentId,
    variant: variant
  }), categoryArray.length === 1 && (0, _array.isArrayOfLength)(categoryArray[0].items) && categoryArray[0].items.map((category, i) => /*#__PURE__*/_react.default.createElement(_MenuDrawer.default, {
    bundledStyles: merge(bundledStyles, {
      customParentButtonStyles: parentButtonStyles
    }),
    customTheme: customTheme,
    key: `category_${i}`,
    backLabel: "Main Menu",
    category: category,
    headerPath: category.headerPath,
    isDesktop: isDesktop,
    label: category.label,
    logo: logo,
    path: category.path,
    variant: (0, _string.isStringOfLength)(category.variant) ? category.variant : variant
  })), categoryArray.length > 1 && categoryArray.map((category, i) => /*#__PURE__*/_react.default.createElement(_MenuDrawer.default, {
    bundledStyles: merge(bundledStyles, {
      customParentButtonStyles: parentButtonStyles
    }),
    customTheme: customTheme,
    drawerClassName: category.mobileClassName,
    key: `category_${i}`,
    backLabel: "Main Menu",
    category: category,
    headerPath: category.headerPath,
    isDesktop: isDesktop,
    isNew: category.isNew,
    label: category.label,
    logo: logo,
    path: category.path,
    variant: (0, _string.isStringOfLength)(category.variant) ? category.variant : variant
  })), categoryArray.length > 0 && supplementalFragment && /*#__PURE__*/_react.default.createElement(_material.Divider, {
    sx: dividerStyles,
    "data-testid": testIdMap.dividerTestId
  }), supplementalFragment && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "navigation-mobile__fragments",
    sx: fragmentStyles
  }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: supplementalFragment
  }))));
};

// Define propTypes;
NavigationMobile.propTypes = {
  /** Define anchor point of initial Menu Drawer for positioning (Default Value: "right") */
  anchor: _propTypes.default.oneOf(["left", "right", "top", "bottom"]),
  /** Boolean to open mobile navigation by default (Default Value: false) */
  autoOpen: _propTypes.default.bool,
  /** Collection of custom style objects (Default Value: {}) */
  bundledStyles: _propTypes.default.shape({
    /** Custom styles for navigation drawer back to prior buttons */
    customBackButtonStyles: _propTypes.default.object,
    /** Custom styles for Drawer Buttons */
    customButtonStyles: _propTypes.default.object,
    /** Custom styles for slide-out menu drawers */
    customDrawerStyles: _propTypes.default.object,
    /** Custom styles for paper component in each Menu Drawer*/
    customDrawerPaperStyles: _propTypes.default.object,
    /** Custom styles for fragment imports */
    customFragmentStyles: _propTypes.default.object,
    /** Custom styles for Menu Drawer Headings */
    customHeadingStyles: _propTypes.default.object,
    /** Custom styles for sign in menu drawer button */
    customSignInButtonStyles: _propTypes.default.object,
    /** Custom styles for Lists */
    customListStyles: _propTypes.default.object,
    /** Custom styles for list items */
    customListItemStyles: _propTypes.default.object,
    /** Custom styles for logo components */
    customLogoStyles: _propTypes.default.object
  }),
  /** Category Array describing navigation structure */
  categoryArray: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** @ignore */
  indicator: _propTypes.default.string,
  /** Boolean to indicate if if header is in desktop mode */
  isDesktop: _propTypes.default.bool,
  /** Object describing logo image attributes */
  logo: _propTypes.default.shape({
    /** Alt. Description for image (Default Value: "The Pennsylvania Higher Education Assistance Agency") */
    alt: _propTypes.default.string.isRequired,
    /** Height Value (Default Value: "5.4rem") */
    height: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
    /** URL for Image (Default Value: "/general/images/header/logo.svg") */
    src: _propTypes.default.string.isRequired,
    /** Width Value (Default Value: "13.7rem") */
    width: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string])
  }),
  /** Content fragment for sign-in information */
  signInFragmentId: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /** Content fragment for supplemental navigation links (Default Value: "13dqqi7") */
  supplementalFragment: _propTypes.default.oneOfType([/** String containing fragmentID */
  _propTypes.default.string, /** Boolean to deactivate supplimental fragment display */
  _propTypes.default.bool]),
  /** @ignore */
  testId: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /** Drawer Style variants */
  variant: _propTypes.default.oneOf(["default", "default--noHeader", "inverse", "inverse--noHeader"])
};

// Export component as default;
var _default = exports.default = NavigationMobile;